import CustomInput from "components/Common/CustomInput"
import { addCategoryImageSchema } from "components/Schemas/addCategorySchema"
import { useFormik } from "formik"
import { post } from "helpers/api_helper"
import { toaster } from "helpers/Custom/Toaster"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Modal } from "reactstrap"

const AddCategoryImg = ({ open, close, edit, mutate }) => {
  const { id } = useParams()
  const [file, setFile] = useState([])
  const [initValues, setInitValues] = useState(null)

  useEffect(() => {
    if (edit?.image) {
      const value = { ...initValues }
      value.image = edit?.image || ""
      setInitValues(value)
    }
  }, [edit?.image])

  const onSubmit = async (values, { setSubmitting }) => {
    const formData = new FormData()
    file?.length ? formData.append("image", file?.[0]) : null
    formData.append("category", id)
    for (const obj of formData.entries()) {
      console.log(obj)
    }
    try {
      let postData
      if (edit?.image) {
        postData = await post("/edit-image-to-category", formData, {
          headers: {
            id: edit?.id,
          },
        })
      } else {
        postData = await post("/add-image-to-category", formData)
      }
      console.log(`postData`, postData)
      if (postData) {
        mutate()
        close()
        toaster("success", postData?.message)
      }
      setSubmitting(false)
    } catch (err) {
      setSubmitting(false)
      toaster(
        "error",
        err?.response?.data?.message ||
          `${edit?.image ? "Update" : "Add"} category image failed`
      )
    }
  }
  const addCategory = useFormik({
    enableReinitialize: true,
    initialValues: initValues || { file: "", image: "" },
    validationSchema: addCategoryImageSchema,
    onSubmit,
  })
  // console.log(`addCategory`, addCategory)
  return (
    <React.Fragment>
      <Modal
        isOpen={open}
        toggle={() => close(false)}
        size="lg"
        centered={true}
      >
        <form onSubmit={addCategory.handleSubmit}>
          <div className="d-flex align-items-center px-3 py-3 border-bottom">
            <h2 className="flex-grow-1 mb-0">Add Category Images</h2>
            <button
              type="button"
              onClick={() => {
                close(false)
              }}
              className="modalClose d-flex justify-content-center align-items-center"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="p-3">
            <div className="addCategoryInp ">
              <div className="input-group mb-3">
                <CustomInput
                  validationType={addCategory}
                  name="file"
                  type={"file"}
                  handleChange={e => setFile(e.target.files)}
                  className="w-100 form-control"
                  label={"Select File"}
                />
              </div>
              {edit?.image && file?.length === 0 ? (
                <img src={edit?.image} width="50px" alt="image" />
              ) : null}
            </div>
          </div>
          <div className="modalFooter d-flex justify-content-end py-3 px-3">
            <button
              className="btn btn-danger mx-2"
              onClick={() => {
                close(false)
              }}
            >
              Cancel
            </button>{" "}
            <button
              type="submit"
              disabled={addCategory.isSubmitting}
              className="btn btn-success "
            >
              {addCategory.isSubmitting ? "Submitting..." : "Save"}
            </button>
          </div>
        </form>
      </Modal>
    </React.Fragment>
  )
}

AddCategoryImg.propTypes = {
  open: PropTypes.any,
  close: PropTypes.func,
  mutate: PropTypes.func,
  edit: PropTypes.object,
}

export default AddCategoryImg
